module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4xODYiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCA4LjA5MyAxNCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ViNTUwNTsKICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJfIiBkYXRhLW5hbWU9IiZndDsiIGNsYXNzPSJjbHMtMSIgZD0iTTU0Mi40MTYsNTIwLjc4MWw1LjM5NSw1LjYwOC0xLjM0OSwxLjQtNS4zOTUtNS42MDctMS4zNDktMS40LDEuMzQ5LTEuNCw1LjM5NS01LjYwNiwxLjM0OSwxLjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTM5LjcxOSAtNTEzLjc4MSkiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-left-orange.svg
// module id = 2irt
// module chunks = 0